import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { OperationPorteurSearch, TelechargementOperations, OperationSearch } from '@/models/operationssearch.model'

export default {
  data () {
    return {
      loading: false,
      formatReleve: ['EXCEL', 'Bureautique', 'Fixe'],
      listeReleves: [],
      relevesSearch: new OperationPorteurSearch(),
      releveToDownload: new OperationSearch(),
      telechargementOperations: new TelechargementOperations()
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    getFileOperationsPorteur () {
      this.telechargementOperations.dateDebut = this.relevesSearch.dateDebut
      this.telechargementOperations.dateFin = this.relevesSearch.dateFin
      this.telechargementOperations.format = this.relevesSearch.format
      this.telechargementOperations.selectedEntreprise = this.$store.state.user.user.selectedEntreprise
      this.telechargementOperations.loggedUserLogin = this.$store.state.user.user.login

      let responseTypeFile = 'json'
      let extension = '.txt'
      if (this.telechargementOperations.format === 'EXCEL') {
        extension = '.xls'
        responseTypeFile = 'blob'
      }

      this.$store.dispatch('entreprise/getFileOperationsPorteur', [this.telechargementOperations, responseTypeFile]).then(
        response => {
          this.loading = false
          if (this.telechargementOperations.format === 'EXCEL') {
            let blob = new Blob([response], { type: 'application/vnd.ms-excel' })

            if ('msSaveOrOpenBlob' in navigator) {
              window.navigator.msSaveOrOpenBlob(blob, 'export' + extension)
            } else {
              var hiddenElement = document.createElement('a')
              hiddenElement.href = URL.createObjectURL(blob)
              hiddenElement.target = '_blank'
              hiddenElement.download = 'export' + extension
              document.body.appendChild(hiddenElement)
              hiddenElement.click()
              document.body.removeChild(hiddenElement)
            }
          } else {
            this.fileContent = window.atob(response.encodedFile)
            if ('msSaveOrOpenBlob' in navigator) {
              let byteNumbers = new Array(this.fileContent.length)
              for (var i = 0; i < this.fileContent.length; i++) {
                byteNumbers[i] = this.fileContent.charCodeAt(i)
              }
              const byteArray = new Uint8Array(byteNumbers)
              window.navigator.msSaveOrOpenBlob(new Blob([byteArray]), response.fileName.concat(extension))
            } else {
              hiddenElement = document.createElement('a')
              hiddenElement.href = 'data:application/file;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(this.fileContent)
              hiddenElement.target = '_blank'
              hiddenElement.download = response.fileName.concat(extension)
              document.body.appendChild(hiddenElement)
              hiddenElement.click()
              document.body.removeChild(hiddenElement)
            }
          }
        },
        error => {
          this.errorMessage = error.response
          this.loading = false
        }
      )
    },
    downloadFile (fileToDownload) {
      this.releveToDownload.login = this.$store.state.user.user.login
      this.releveToDownload.groupName = this.$store.state.user.user.groupe.name
      this.releveToDownload.fileToDownload = fileToDownload.absolutePath
      this.releveToDownload.keyFolder = fileToDownload.keyFolder
      let finalFileName = fileToDownload.nomFichierTelecharge

      this.$store.dispatch('entreprise/downloadRapportFile', this.releveToDownload).then(
        response => {
          if ('msSaveOrOpenBlob' in navigator) {
            window.navigator.msSaveOrOpenBlob(new Blob([response], { type: 'application/txt' }), finalFileName)
          } else {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = URL.createObjectURL(new Blob([response], { type: 'application/txt' }))
            hiddenElement.target = '_blank'
            hiddenElement.download = finalFileName
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)
          }
          this.loading = false
        },
        error => {
          this.errorMessage = error.response
          this.loading = false
        }
      )
    },
    getSublist (listToSplit, index, nbElementsToDisplay) {
      return listToSplit.slice((nbElementsToDisplay * index), (nbElementsToDisplay + (nbElementsToDisplay * index)))
    }
  },
  mounted () {
    var self = this
    $( function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.relevesSearch.dateDebut = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.relevesSearch.dateFin = dateText
        }
      })
    })

    this.loading = true
    this.relevesSearch.format = 'EXCEL'
    let dateDebut = new Date()
    dateDebut.setDate(1)

    let dateFin = new Date()
    this.relevesSearch.dateDebut = dateDebut.toISOString().substr(0, 10)
    this.relevesSearch.dateFin = dateFin.toISOString().substr(0, 10)

    this.telechargementOperations.selectedEntreprise = this.$store.state.user.user.selectedEntreprise
    this.telechargementOperations.loggedUserLogin = this.$store.state.user.user.login

    this.$store.dispatch('entreprise/getRelevesOperations', this.telechargementOperations).then(
      response => {
        this.loading = false
        this.listeReleves = response
      },
      error => {
        this.errorMessage = error.response
        this.loading = false
      }
    )
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Téléchargements'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
